import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import BottomBar from "./BottomBar";
import "./index.scss";
import { Grid } from "antd";

const DashboardLayout = () => {
  const { pathname } = useLocation();
  const { useBreakpoint } = Grid;
  const { md } = useBreakpoint();
  const isMobile = md === false;
  const isAddJob = () =>
    pathname === "/dashboard/jobs/add-job" ||
    pathname === "/dashboard/jobs/preview-job";

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const header = document.querySelector(".mobile-top");
    const scrollTop = window.scrollY;
    scrollTop >= 100
      ? header?.classList?.add("is-sticky")
      : header?.classList?.remove("is-sticky");
  };

  const showMobileBars = () => {
    if (isMobile) {
      return !isAddJob();
    }
    return false;
  };

  return (
    <div className="dashboard-layout-container d-flex">
      <NavBar />
      <div className="dashboard-layout-right">
        <TopBar />
        <div className={isAddJob() ? "add-internal" : "internal-container"}>
          <Outlet />
        </div>
        {showMobileBars() && <BottomBar />}
      </div>
    </div>
  );
};

export default DashboardLayout;
